module.exports = __webpack_public_path__ + "media/application/images/svgs/octagon-26a3c1896e40bc1ee9ef67e1f3404139.svg";